import { LOGO_LOADING } from '@/lib/assetUrl';
import { t } from '@/lib/i18n';
import '@/styles/auth-loading.css';

export function AuthLoading() {
  return (
    <div className="auth-loading-screen">
      <img src={LOGO_LOADING} alt="Republic Origins" className="auth-loading-logo" />
      <p className="auth-loading-text">{t('auth_loading')}</p>
      <div className="auth-loading-spinner" aria-hidden />
    </div>
  );
}

export function AuthError({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="auth-loading-screen auth-loading-error">
      <img src={LOGO_LOADING} alt="Republic Origins" className="auth-loading-logo auth-loading-logo-sm" />
      <p className="auth-loading-text">{message || t('auth_error')}</p>
      {onRetry && (
        <button type="button" className="battlepass-btn" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}
